import Nav from "../../../shared/header/navigation.short.m";
import Form from "./form.m";
import m from "mithril";
export default {
    view() {
        return (m("article", { class: "form catalog-form-wrapper" },
            m("div", { class: "wrapper" },
                m(Form, null),
                m("div", { class: "tr mt2" },
                    m(Nav, null)))));
    },
};
